import React from 'react';

const awsServices = [
  {
    name: 'AWS Amplify',
    description: 'Full-stack app platform for hosting, backend, and CI/CD',
    category: 'Platform',
  },
  {
    name: 'Amazon Bedrock',
    description: 'Foundation models for generative AI features',
    category: 'AI/ML',
  },
  {
    name: 'AWS Lambda',
    description: 'Serverless compute for scalable backend logic',
    category: 'Compute',
  },
  {
    name: 'Amazon DynamoDB',
    description: 'NoSQL database for millisecond performance at scale',
    category: 'Database',
  },
  {
    name: 'Amazon Cognito',
    description: 'User authentication and identity management',
    category: 'Security',
  },
  {
    name: 'AWS AppSync',
    description: 'Managed GraphQL APIs with real-time subscriptions',
    category: 'API',
  },
  {
    name: 'Amazon S3',
    description: 'Object storage for assets, media, and backups',
    category: 'Storage',
  },
  {
    name: 'Amazon CloudFront',
    description: 'Global CDN for fast content delivery worldwide',
    category: 'Networking',
  },
  {
    name: 'Amazon SageMaker',
    description: 'Custom ML model training and deployment',
    category: 'AI/ML',
  },
  {
    name: 'Amazon SNS',
    description: 'Push notifications across iOS and Android',
    category: 'Messaging',
  },
  {
    name: 'AWS CloudWatch',
    description: 'Monitoring, logging, and observability',
    category: 'Operations',
  },
  {
    name: 'AWS CodePipeline',
    description: 'Automated CI/CD for continuous delivery',
    category: 'DevOps',
  },
];

const Technology = () => {
  return (
    <section id="technology" className="technology section">
      <div className="container">
        <div className="section__header">
          <span className="section__tag">Technology Stack</span>
          <h2 className="section__title">
            Built on
            <span className="gradient-text"> Amazon Web Services</span>
          </h2>
          <p className="section__subtitle">
            Our entire infrastructure runs on AWS, giving us access to the world's
            most comprehensive cloud platform. We leverage over a dozen AWS services
            to deliver secure, scalable, and intelligent mobile applications.
          </p>
        </div>

        <div className="technology__banner">
          <div className="technology__banner-content">
            <div className="technology__aws-badge">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
                <path d="M2.25 15a4.5 4.5 0 004.5 4.5H18a3.75 3.75 0 001.332-7.257 3 3 0 00-3.758-3.848 5.25 5.25 0 00-10.233 2.33A4.502 4.502 0 002.25 15z" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
              <span>AWS Partner</span>
            </div>
            <h3>Committed to the AWS Ecosystem</h3>
            <p>
              As a dedicated AWS customer, we build exclusively on Amazon Web Services.
              Our deep expertise across the AWS platform allows us to architect solutions
              that are secure, cost-effective, and infinitely scalable. We are committed
              to leveraging AWS innovations including generative AI through Amazon Bedrock
              to deliver next-generation mobile experiences.
            </p>
          </div>
        </div>

        <div className="technology__grid">
          {awsServices.map((service, index) => (
            <div key={index} className="technology__card">
              <div className="technology__card-header">
                <span className="technology__card-category">{service.category}</span>
              </div>
              <h4 className="technology__card-name">{service.name}</h4>
              <p className="technology__card-desc">{service.description}</p>
            </div>
          ))}
        </div>

        <div className="technology__architecture">
          <h3 className="technology__architecture-title">Our Architecture Philosophy</h3>
          <div className="technology__architecture-grid">
            <div className="technology__architecture-item">
              <div className="technology__architecture-number">01</div>
              <h4>Serverless First</h4>
              <p>We default to serverless. AWS Lambda and managed services mean we pay only for what we use and scale automatically to meet demand.</p>
            </div>
            <div className="technology__architecture-item">
              <div className="technology__architecture-number">02</div>
              <h4>Event-Driven</h4>
              <p>Our backends are event-driven architectures using SNS, SQS, and EventBridge, enabling loose coupling and high resilience.</p>
            </div>
            <div className="technology__architecture-item">
              <div className="technology__architecture-number">03</div>
              <h4>AI-Augmented</h4>
              <p>Every data flow is an opportunity for intelligence. We integrate Bedrock and SageMaker throughout our pipelines for smarter experiences.</p>
            </div>
            <div className="technology__architecture-item">
              <div className="technology__architecture-number">04</div>
              <h4>Security by Default</h4>
              <p>IAM policies, encryption at rest and in transit, Cognito authentication, and WAF protection are non-negotiable in every deployment.</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Technology;
